module.exports = __webpack_public_path__ + "media/images/icon__live@2x-8d904c6c92560cef3be4339a703e8c61.png";